module.exports = __webpack_public_path__ + "static/media/image-3.0d61e95c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Neighborhood/image-3.png
// module id = 264
// module chunks = 0